"use client";
import {
  accordion_default
} from "./chunk-AHU2EXT2.mjs";
import "./chunk-3XWHXVUH.mjs";
import {
  useAccordionItem
} from "./chunk-XGGOPONM.mjs";
import {
  useAccordion
} from "./chunk-PNGZVYML.mjs";
import {
  accordion_item_base_default
} from "./chunk-LDUMD4XQ.mjs";
export {
  accordion_default as Accordion,
  accordion_item_base_default as AccordionItem,
  useAccordion,
  useAccordionItem
};
